import { useMutation, useQueryClient } from '@tanstack/react-query';
import reviewServices from '../services/review.service';
import toast from 'react-hot-toast';

export const useToggleReviewVisibility =
  () => {
    const queryClient =
      useQueryClient();

    return useMutation({
      mutationFn: (payload) =>
        reviewServices.toggleVisibility(
          payload
        ),

      onSuccess: (data) => {
        toast.success(
          data?.message ||
            'Review updated'
        );

        queryClient.invalidateQueries({
          queryKey: ['reviews'],
        });
      },

      onError: (error) => {
        toast.error(
          error?.response?.data
            ?.message ||
            'Failed to update review'
        );
      },
    });
  };